import React, {FC} from "react";
import {DatePicker, Form, Select} from "antd";
import {localize} from "mixins/helpers";
import {LOAD_TYPES, MONTH_NUMBERS_TYPES} from "/site/parts/calc-transport/calc-transport-consts";

const TruckForm: FC = (props: any) => {
    return (
        <Form form={props.form} className="w-100">
            <Form.Item name="year" rules={[ {
                required: true,
                message: localize('meta.error.invalid-data', props.translations)
            } ]}>
                <DatePicker
                    placeholder={localize('calc-transport-criteria-2', props.translations)}
                    format={'YYYY'}
                    picker="year"
                />
            </Form.Item>

            <Form.Item name="numberOfMonthsInUse">
                <Select options={MONTH_NUMBERS_TYPES} placeholder={localize('calc-transport-criteria-3', props.translations)} />
            </Form.Item>

            <Form.Item name="loadCapacityId">
                <Select
                    options={LOAD_TYPES.map((e) => ({
                        key: e.key,
                        value: e.value,
                        label: localize(e.label, props.translations),
                    }))}
                    placeholder={localize('calc-transport-criteria-4', props.translations)}
                />
            </Form.Item>
        </Form>
    );
};

export default TruckForm;
